import { FindingGenomicData } from '../models/finding'

export const getGenomeCoords = (genomicData: FindingGenomicData) =>
	`${genomicData.chromosome}:${genomicData.position}:${genomicData.alteration}`
